import { Flex, Heading, Spacer } from '@chakra-ui/react';
export const Navbar = () => {
  return (
    <Flex d={['none', 'none', 'unset']}>
      <Heading>Websocket chat</Heading>
    </Flex>
  );
};
